function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarmRanch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,45.098039%,77.647059%)",
      fillOpacity: 1
    },
    d: "M 13.332031 8.332031 C 12.414062 8.332031 11.667969 9.078125 11.667969 10 C 11.667969 10.921875 12.414062 11.667969 13.332031 11.667969 L 16.667969 11.667969 C 17.585938 11.667969 18.332031 10.921875 18.332031 10 C 18.332031 9.078125 17.585938 8.332031 16.667969 8.332031 Z M 13.332031 8.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0.392157%,45.098039%,77.647059%)",
      fillOpacity: 1
    },
    d: "M 16.171875 0.324219 C 15.414062 0.0429688 14.585938 0.0429688 13.828125 0.324219 L 6.617188 3.03125 C 5.921875 3.289062 5.335938 3.773438 4.949219 4.40625 L 0.246094 12.042969 C -0.234375 12.828125 0.0078125 13.851562 0.792969 14.335938 C 1.066406 14.503906 1.367188 14.582031 1.667969 14.582031 L 1.667969 26.664062 C 0.746094 26.664062 0 27.410156 0 28.332031 C 0 29.253906 0.746094 30 1.667969 30 L 9.949219 30 C 9.964844 30 9.984375 30 10 30 L 20 30 C 20.019531 30 20.035156 30 20.050781 30 L 28.332031 30 C 29.253906 30 30 29.253906 30 28.332031 C 30 27.410156 29.253906 26.664062 28.332031 26.664062 L 28.332031 14.582031 C 28.632812 14.582031 28.933594 14.503906 29.207031 14.335938 C 29.992188 13.851562 30.234375 12.828125 29.753906 12.042969 L 25.050781 4.402344 C 24.664062 3.773438 24.078125 3.289062 23.382812 3.03125 Z M 25.007812 10.691406 L 22.214844 6.152344 L 15 3.445312 L 7.785156 6.152344 L 4.992188 10.691406 C 4.996094 10.738281 5 10.785156 5 10.832031 L 5 26.664062 L 8.332031 26.664062 L 8.332031 15 C 8.332031 14.078125 9.078125 13.332031 10 13.332031 L 20 13.332031 C 20.921875 13.332031 21.667969 14.078125 21.667969 15 L 21.667969 26.664062 L 25 26.664062 L 25 10.832031 C 25 10.785156 25.003906 10.738281 25.007812 10.691406 Z M 16.332031 16.667969 L 11.667969 23.660156 L 11.667969 16.667969 Z M 18.332031 26.664062 L 13.671875 26.664062 L 18.332031 19.671875 Z M 18.332031 26.664062 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmRanch);
export default __webpack_public_path__ + "static/media/FarmRanch.f4372274.svg";
export { ForwardRef as ReactComponent };